export var observable = Symbol.observable || "@@observable";
//# sourceMappingURL=symbols.js.map
